/**
 * Coerce an API response to an array before iterating it.
 *
 * `data ?? []` is the reflex, and it only guards `null`/`undefined`. Anything
 * else non-array — an error envelope, a paginated wrapper, a contract that
 * changed — flows straight into `.map`, `.filter` or a spread and throws. These
 * run inside the app shell, so the throw reaches the error boundary and takes
 * down the entire page, not just the widget that asked.
 *
 * Three separate crashes of exactly this shape were found in one pass (the
 * signature list, the outreach signature list, and the candidate timeline),
 * which is why it is a helper rather than three inline checks.
 */
export function asArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : []
}
